define('app/views/deal_page_slider_view',['app/setup', 'jquery.easing', 'jquery.mobileJustTouch', 'mighty-slider'], function (takhfifan, easing, mobileJustTouch, mightyslider) {

  takhfifan.dealPageSliderView = takhfifan.BaseView.extend({

    initialize: function () {
      var _this = this;
      $('.sliders-wrapper').removeClass('loading');
      $('.sliders-wrapper .deal-page-card-loading').fadeOut(500);
      var slidesLength = $('#deal-page-slider').find('.slide_element').find('div.slide').length;
      $('.slides-counter .slides-length').text(slidesLength);

      var firstSlideImage = $('.sliders-wrapper').find('.slide')[0];
      this.loadImage(firstSlideImage);

      function getViewport() {
        var e = window;
        var a = 'inner';
        if (!('innerWidth' in window)) {
          a = 'client';
          e = document.documentElement || document.body;
        }
        return {
          width: e[a + 'Width'],
          height: e[a + 'Height']
        }
      }

      jQuery(document).ready(function ($) {
        var $win = $(window),
          isTouch = !!('ontouchstart' in window),
          clickEvent = isTouch ? 'tap' : 'click';

        (function () {
          /**
           * Calculate the slides width in percent based on the parent's width.
           *
           * @return {String}
           */
          function calculator(width) {
            var percent = '50%';

            if (width <= 480) {
              percent = '100%';
            } else if (width <= 767) {
              percent = '100%';
            }

            return percent;
          };

          // Global slider's DOM elements
          var $example = $('#deal-page-slider'),
            $frame = $('.frame', $example);

          // Calling new mightySlider class
          var slider = new mightySlider($frame,
            {
              speed: 1500,
              startAt: 1,
              autoScale: 1,
              easing: 'easeOutExpo',
              viewport: 'fill',
              preloadMode: 'instant',

              // Navigation options
              navigation: {
                slideSize: calculator(getViewport().width),
                keyboardNavBy: 'slides',
                activateOn: clickEvent,
                isRtl: true,
              },

              // Dragging options
              dragging: {
                swingSpeed: 0.12,
                onePage: 1
              },

              // Buttons options
              buttons: !isTouch ? {
                prev: $('a.mSPrev', $frame),
                next: $('a.mSNext', $frame)
              } : {},

              // Cycling options
              cycling: {
                cycleBy: 'slides',
                pauseTime: 6000,
                loopMode : 'pingpong' // it can be 'normal', 'pingpong' or 'immediate' 1807-tame-the-slider
              }
            },

            // Register callbacks to the events
            {
              // Register mightySlider :active event callback
              active: function (name, index) {
                $('.slides-counter .active-slide-index').text(index + 1);
                var slideOptions = this.slides[index].options;

                //lazy loading
                var lazyBufferSize = 2;
                var slidesCount = this.slides.length;

                var upperBound = Math.min(slidesCount - 1, index + lazyBufferSize);
                for(var i = index; i <= upperBound; i++) {
                  var el = $(this.slides[i].element);
                  if (!(el.hasClass('lazy-loaded'))) {
                    _this.loadImage(el);
                  }
                }
              }
            });

          slider.init();

          // Register window :resize event callback
          $win.resize(function () {
            // Update slider options using 'set' method
            slider.set({
              navigation: {
                slideSize: calculator(getViewport().width)
              }
            });
          });
        })();
      });
    },

    loadImage: function (el) {
      var slideImage = $(el).find('img');
      slideImage.prop('src', slideImage.data('src'));
      $(el).addClass('lazy-loaded');
    }
  });
});

